<template>
  <b-card no-body class="shadow h-100 flex-container grid-stack-item-content">
    <div slot="header">
      <window-header cmp-title="History options" widget-name="history-opts"></window-header>
    </div>
      <div class="flex-full-height p-4">
        <b-row>
          <b-col sm="12"><label >Date range:</label></b-col>
        </b-row>

        <b-row >
          <b-col sm="6">
            <b-form-input  type="date" v-model="$store.getters['project/historyOpts']['start_date']"></b-form-input>
          </b-col>
          <b-col sm="6">
            <b-form-input  type="date" v-model="$store.getters['project/historyOpts']['end_date']"></b-form-input>
          </b-col>
        </b-row>

        <hr/>

        <div class="row"><b-col sm="12">
          <label>Operations:</label>
        </b-col></div>

        <b-row>
          <b-col sm="12">
            <b-form-checkbox-group v-model="$store.getters['project/historyOpts']['ops']" :options="ops" >
            </b-form-checkbox-group>
          </b-col>
        </b-row>

        <hr/>

        <b-row><b-col sm="12">
          <label>Tables:</label>
        </b-col>
        </b-row>

        <b-row>
          <b-col sm="12">
            <b-form-checkbox-group v-model="$store.getters['project/historyOpts']['tables']" :options="tables" >
            </b-form-checkbox-group>
          </b-col>
        </b-row>

        <hr/>

        <b-row>
          <b-col sm="6"><label>Record budget:</label></b-col>
          <b-col sm="6">
            <b-form-input v-model="$store.getters['project/historyOpts']['rec_budget']"
                          type="number"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="12">
            <b-form-checkbox
              v-model="$store.getters['project/historyOpts']['excludeAnonym']"
              :value="true"
              :unchecked-value="false">
              Last modified user not empty
            </b-form-checkbox>
          </b-col>
        </b-row>

        <!--<b-row>
          <b-col></b-col>
          <b-button href="#"
                    variant="primary">Apply</b-button>
        </b-row>-->
      </div>


    </b-card>
</template>

<script>
  import WindowHeader from './common/WindowHeader'
  export default {
    name: 'HistoryOpts',
    components: {WindowHeader},
    data () {
      return {
        ops: ["INSERT", "UPDATE", "DELETE"].map(o => {
          return {
            value: o,
            text: o
          }
        }),
        tables: ["centrelines", 'wells'].map(o => {
          return {
            value: o,
            text: o
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HistoryOpts.vue